import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BusTypeController from "../../../../services/system/bus/bus-type-controller";
import Utils from "../../../../utils/utils";
import DatePicker from "react-datepicker";
import BusRouteController from "../../../../services/system/bus/bus-route-controller";

class ModalCancelRegisterBus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            dateCancel:  new Date(),
            id: -1,
            price: 0,
            status: true,
            state: "ACTIVE"
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState(nextProps.item)
            this.setState({
                routeBusName: nextProps.routeBusName,
                id: nextProps.item?.id,
                fullName: nextProps.item?.fullName,
                busType: nextProps.item?.busTypeRes.name,
                priceType: nextProps.item?.priceType,
            })
            console.log(nextProps.item);
        }
    }
    cancelService = () => {
        let payload = {
            "endDay": this.state.dateCancel,
            "id": this.state.id,
        }
        BusRouteController.cancelBusUserRegister(payload, res => {
            if (res.success) {
                toast.success("Hủy dịch vụ thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Hủy dịch vụ xe bus</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2"></div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Tên tuyến</label>
                                    <label className="col-8 label-item pl-0"><b>{this.state.routeBusName}</b></label>
                                </div>
                                <div className="col-12 d-flex mb-2"></div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Loại dịch vụ</label>
                                    <label className="col-8 label-item pl-0"><b>{this.state.busType}</b></label>
                                </div>
                                <div className="col-12 d-flex mb-2"></div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Số tháng đăng ký</label>
                                    <label className="col-7 label-item pl-0"><b>{this.state.priceType} tháng</b></label>
                                </div>
                                <div className="col-12 d-flex mb-2"></div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Tên học sinh</label>
                                    <label className="col-8 label-item pl-0"><b>{this.state.fullName}</b></label>
                                </div>

                                <div className="col-12 d-flex mb-2"></div>
                                <div className="col-12 d-flex mb-2"></div>
                                <div className="col-12 d-flex mb-2">
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-12 label-item pl-0">Thời gian kết thúc dịch vụ(<span  style={{color: "red",}}>*</span>)</label>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.dateCancel === '' ? null : new Date(this.state.dateCancel)}
                                        minDate={new Date()}
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                try {
                                                    this.setState({
                                                        dateCancel: date,
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.cancelService()}
                                >
                                        <span className='justify-content-center'>
                                            Đồng ý
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalCancelRegisterBus